import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-185751e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-end mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1))
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_translate = _resolveComponent("translate")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TipTapTextArea = _resolveComponent("TipTapTextArea")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Card = _resolveComponent("Card")!

  return (!_ctx.offer)
    ? (_openBlock(), _createBlock(_component_ProgressBar, {
        key: 0,
        mode: "indeterminate"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            class: "flex-shrink-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateMessageDialog = true))
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode("  "),
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Nachricht verfassen")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Dialog, {
            header: _ctx.i18n.$gettext('Nachricht verfassen'),
            visible: _ctx.showCreateMessageDialog,
            "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCreateMessageDialog) = $event)),
            onHide: _ctx.resetCreateMessageDialog,
            modal: ""
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_Button, {
                label: _ctx.i18n.$gettext('Abbrechen'),
                icon: "pi pi-times",
                class: "p-button-text",
                onClick: _ctx.resetCreateMessageDialog
              }, null, 8, ["label", "onClick"]),
              _createVNode(_component_Button, {
                label: _ctx.i18n.$gettext('Senden'),
                icon: "pi pi-envelope",
                autofocus: "",
                disabled: !_ctx.messageText,
                onClick: _ctx.createMessage
              }, null, 8, ["label", "disabled", "onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_TipTapTextArea, {
                ref: "editor",
                type: "text",
                placeholder: _ctx.i18n.$gettext('Nachricht'),
                modelValue: _ctx.messageText,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.messageText) = $event)),
                modelModifiers: { lazy: true, trim: true },
                required: ""
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _: 1
          }, 8, ["header", "visible", "onHide"])
        ]),
        _createVNode(_component_Card, {
          class: "p-5 mb-4 w-100",
          style: {"max-height":"100vh","overflow-y":"auto"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("h5", _hoisted_4, [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Nachrichten")
                ]),
                _: 1
              })
            ])
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sort(_ctx.messages?.data || []), (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(_ctx.isInternal(message) ? 'message-int' : 'message-ext')
                }, [
                  _createElementVNode("p", {
                    class: "m-0",
                    innerHTML: _ctx.safeRender(message.messageText)
                  }, null, 8, _hoisted_6)
                ], 2))
              }), 256))
            ])
          ]),
          _: 1
        })
      ]))
}